export const id = <T>(e: T): T => e;
